import Vue from 'vue';
import Flickity from 'vue-flickity';
import './styles/celebrates.scss';

// let Flickity = require('flickity');
require('flickity-as-nav-for');

Vue.config.productionTip = false
Vue.component('flickity', Flickity.default || Flickity);


// WEBPACK FOOTER //
// ./src/celebrates.js